<template>
  <div id="app">
    <el-container class="form">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Проверка чека</span>
        </div>
        <el-form :model="form">
          <el-alert v-if="form.error" type="error" :closable="false">{{
            form.error
          }}</el-alert>
          <el-form-item label="Серия">
            <el-input v-model="form.series" maxlength="6"></el-input>
          </el-form-item>
          <el-form-item label="Номер">
            <el-input v-model="form.ticket" maxlength="6"></el-input>
          </el-form-item>
        </el-form>
        <el-button
          @click="getUrl()"
          type="primary"
          :disabled="form.series.length !== 6 || form.ticket.length !== 6"
          >Получить чек</el-button
        >
      </el-card>
    </el-container>
  </div>
</template>

<script>
import Axios from "axios";
import pad from "pad";

const axios = Axios.create({
  baseURL:
    process.env.NODE_ENV == "production"
      ? "https://scurl.ru/"
      : "http://localhost:3000/",
  timeout: 30000,
});

export default {
  name: "app",
  components: {},
  data: () => ({
    form: {
      series: "",
      ticket: "",
      error: "",
    },
  }),
  mounted() {
    const location = new URL(window.location.href).pathname
      .split("/")
      .filter((e) => e);

    if (location.length == 2) {
      const [series, ticket] = location.map((e) => parseInt(e));
      if (series > 0 && series < 1000000 && ticket > 0 && ticket < 1000000) {
        this.form.series = pad(6, series, "0");
        this.form.ticket = pad(6, ticket, "0");
      }
    }
  },
  methods: {
    async getUrl() {
      let result = await axios.get(
        `/api/ticket/url/${this.form.series}/${this.form.ticket}`,
        {
          validateStatus: () => true,
        }
      );

      if (result.data && result.data.status == "success") {
        window.location.href = result.data.data.url;
      } else {
        this.form.error = result.data.message;
      }
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
.form {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.box-card {
  width: 300px;
  padding: 16px;
}
</style>
